export const addonCategorySelectFormChange = ( name, value )   => dispatch => dispatch({ type: `ADDON-CATEGORY-SELECT-FORM-CHANGE`, name,value } );
export function setAddon( addons )  {
    return function (dispatch) {
        let addon = addons && addons.data && addons.data.data;
        dispatch({type: `SET-ADDON`, addon});
    }
}
export const setDefaultAddonForm = ()         => dispatch => dispatch({ type: `SET-DEFAULT-ADDON-FORM` } );
export const setBranchDataAddon = ( branchData )         => dispatch => dispatch({ type: `SET-BRANCH-DATA-ADDON`, branchData:branchData.data.details } );
